import { defineMessages } from "react-intl";

export const giftCardUpdateBalanceDialogMessages = defineMessages({
  title: {
    id: "tKxCld",
    defaultMessage: "Set balance",
    description: "set balance dialog title label",
  },
  subtitle: {
    id: "kFkMoG",
    defaultMessage:
      "What would you like to set cards balance to. When you change the balance both values will be changed",
    description: "set balance dialog subtitle",
  },
  updatedSuccessAlertTitle: {
    id: "XAPFHP",
    defaultMessage: "Successfully updated card balance",
    description: "card update success alert title",
  },
  changeButtonLabel: {
    id: "STJx8N",
    defaultMessage: "Change",
    description: "change button label",
  },
});
